// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3NTWh","head":"Table_head__2l-YO","col":"Table_col__3yvSN"};